import HistoricalNotes from '../pages/HistoricalNotes';
import HistoricalDocuments from '../pages/HistoricalDocuments';
import Timesheet from '../pages/Timesheet';
import DataDashboardGate from '../pages/DataDashboardGate';
import QADashboard from '../pages/QADashboard';
import { Roles } from '../constants';
import HistoricalDocumentsCalendarView from '../pages/HistoricalDocumentsCalendarView';
import SupervisionMetrics from '../pages/SupervisionMetrics';
import TPActivationLogs from '../admin/pages/ManageTreatmentPlan/TPActivationLogs';

export const singleRoutes = [
  {
    path: '/historical-notes',
    type: 'private',
    elem: <HistoricalNotes />,
    roles: [Roles.Prbt, Roles.Admin, Roles.ClientSuccessManager, Roles.Vbt],
  },
  {
    path: '/timesheet',
    type: 'private',
    elem: <Timesheet />,
    roles: [
      Roles.Admin,
      Roles.AssistantAssessor,
      Roles.Bcba,
      Roles.ClientSuccessManager,
      Roles.Prbt,
      Roles.Vbt,
    ],
  },
  {
    path: '/data-dashboard',
    type: 'private',
    elem: <DataDashboardGate />,
    roles: [
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.Admin,
      Roles.ClientSuccessManager,
      Roles.QaSpecialist,
      Roles.Vbt,
      Roles.Prbt,
      Roles.LimitedAccessGuardian,
    ],
  },
  {
    path: '/tp-activation',
    type: 'private',
    elem: <TPActivationLogs />,
    roles: [Roles.Bcba, Roles.Admin],
  },
  {
    path: '/supervision-metrics',
    type: 'private',
    elem: <SupervisionMetrics />,
    roles: [Roles.Bcba, Roles.ClientSuccessManager, Roles.Admin],
  },
  {
    path: '/qa-dashboard',
    type: 'private',
    elem: <QADashboard />,
    roles: [Roles.QaSpecialist, Roles.Admin, Roles.ClientSuccessManager],
  },
  {
    path: '/historical-documents',
    type: 'private',
    elem: <HistoricalDocuments />,
    roles: [
      Roles.Admin,
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.Guardian,
      Roles.InvoiceCoordinator,
      Roles.QaSpecialist,
      Roles.LimitedAccessGuardian,
    ],
    hideForPreClinicalGuardian: true,
  },
  {
    path: '/historical-documents-calendar-view',
    type: 'private',
    elem: <HistoricalDocumentsCalendarView />,
    roles: [Roles.Bcba],
  },
];
